<div class="mb-1 inline" [class.mb-0]="appearance() === 'caption'">
    <span [class]="labelClass"
        ><app-field-name [field]="field()" [viewConfig]="viewConfig()"></app-field-name
    ></span>
</div>
<div>
    <ng-content></ng-content>
</div>
